import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import "./style.css";

const ScrollToTop: React.FC = () => {
  const [visible, setVisible] = useState<boolean>(false);

  // Check Scroll Position
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll to Top Function
  const scrollToTop = (): void => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <motion.div
      className={`scroll-to-top ${visible ? "visible" : ""}`}
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: visible ? 1 : 0, y: visible ? 0 : 50 }}
      transition={{ duration: 0.5 }}
      onClick={scrollToTop}
    >
      <KeyboardArrowUpIcon style={{ color: "white", fontSize: "30px" }} />
    </motion.div>
  );
};

export default ScrollToTop;
